import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import ptBR from "./locales/pt-BR.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import zhCN from "./locales/zh-CN.json";
import zhTW from "./locales/zh-TW.json";
import vi from "./locales/vi.json";

export const SUPPORTED_LANGUAGES = [
    { code: "en", label: "English", flag: "\ud83c\uddec\ud83c\udde7" },
    { code: "es", label: "Espa\u00f1ol", flag: "\ud83c\uddea\ud83c\uddf8" },
    { code: "pt-BR", label: "Portugu\u00eas", flag: "\ud83c\udde7\ud83c\uddf7" },
    { code: "fr", label: "Fran\u00e7ais", flag: "\ud83c\uddeb\ud83c\uddf7" },
    { code: "de", label: "Deutsch", flag: "\ud83c\udde9\ud83c\uddea" },
    { code: "ja", label: "\u65e5\u672c\u8a9e", flag: "\ud83c\uddef\ud83c\uddf5" },
    { code: "ko", label: "\ud55c\uad6d\uc5b4", flag: "\ud83c\uddf0\ud83c\uddf7" },
    { code: "zh-CN", label: "\u7b80\u4f53\u4e2d\u6587", flag: "\ud83c\udde8\ud83c\uddf3" },
    { code: "zh-TW", label: "\u7e41\u9ad4\u4e2d\u6587", flag: "\ud83c\uddf9\ud83c\uddfc" },
    { code: "vi", label: "Ti\u1ebfng Vi\u1ec7t", flag: "\ud83c\uddfb\ud83c\uddf3" },
];

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            es: { translation: es },
            "pt-BR": { translation: ptBR },
            fr: { translation: fr },
            de: { translation: de },
            ja: { translation: ja },
            ko: { translation: ko },
            "zh-CN": { translation: zhCN },
            "zh-TW": { translation: zhTW },
            vi: { translation: vi },
        },
        fallbackLng: "en",
        supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
        nonExplicitSupportedLngs: false,
        load: "currentOnly",
        lowerCaseLng: false,
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"],
            lookupLocalStorage: "gpp_lang",
        },
        interpolation: {
            escapeValue: false,
        },
        returnObjects: false,
        react: {
            useSuspense: false,
        },
    });

// Keep <html lang> in sync with the active language
if (typeof document !== "undefined") {
    document.documentElement.lang = i18n.language || "en";
    i18n.on("languageChanged", (lng) => {
        document.documentElement.lang = lng;
    });
}

export default i18n;
